export default __webpack_public_path__ + "static/media/token_blend.86af53eb.svg";